import { useMutation, useQueryClient } from "@tanstack/react-query"
import useToast from "hooks/useToast"
import { type RefreshResponse, refreshOffers } from "services/offersApi"

const useRefreshOffers = () => {
  const { toast } = useToast()
  const queryClient = useQueryClient()

  const mutation = useMutation<RefreshResponse, Error, void>({
    mutationFn: async () => refreshOffers(),
    onSuccess: (data: RefreshResponse) => {
      const type = data?.success ? "success" : "error"

      if (data?.message) toast(type, data.message)
      queryClient.invalidateQueries({ queryKey: ["offers"] })
    },
    onError: (err: any) => {
      toast("error", err.response.data.message || err.message)
    },
  })

  const refreshOffersHandler = () => mutation.mutate()
  const refreshing = mutation.status === "pending"

  return { refreshOffers: refreshOffersHandler, refreshing }
}

export default useRefreshOffers
